import {
  IESDPCaptainReports,
  IESDPFreeTimeGraph,
  IESDPGroupTeams,
  IESDPIterationReview,
  IESDPTeam,
  IESDPTeamDocument,
  IESDPTeamDocuments,
  IESDPTeamIteration,
  IESDPTeamMaterials,
  IESDPTeams,
} from '@interfaces/IESDP';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IUsersPagination } from '@interfaces/IUser';

export interface IESDPViewState {
  data: IESDPTeams[];
  team: {
    data: IESDPTeam | null;
    isLoading: boolean;
  };
  students: {
    data: IUsersPagination | null;
    isLoading: boolean;
  };
  mentors: {
    data: IUsersPagination | null;
    isLoading: boolean;
  };
  iterations: {
    data: IESDPTeamIteration[];
    currentIteration: IESDPTeamIteration | null;
    review: IESDPIterationReview | null;
    isLoading: boolean;
  };
  iterationCaptainReports: {
    data: IESDPCaptainReports | null;
    isLoading: boolean;
  };
  documents: {
    data: IESDPTeamDocuments | null;
    document: IESDPTeamDocument | null;
    isLoading: boolean;
  };
  materials: {
    data: IESDPTeamMaterials[] | [];
    isLoading: boolean;
  };
  groupTeams: IESDPGroupTeams[] | null;
  freeTimeData: IESDPFreeTimeGraph | null;
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsESDPViewState: IESDPViewState = {
  data: [],
  freeTimeData: null,
  team: {
    data: null,
    isLoading: false,
  },
  students: {
    data: null,
    isLoading: false,
  },
  mentors: {
    data: null,
    isLoading: false,
  },
  iterations: {
    data: [],
    currentIteration: null,
    review: null,
    isLoading: false,
  },
  iterationCaptainReports: {
    data: null,
    isLoading: false,
  },
  documents: {
    data: null,
    document: null,
    isLoading: false,
  },
  materials: {
    data: [],
    isLoading: false,
  },
  groupTeams: null,
  errors: null,
  isLoading: false,
};
